


























    import { ios } from 'bowser';
    import get from 'lodash/get';
    import throttle from 'lodash/throttle';
    import { Component, Prop } from 'vue-property-decorator';
    import { namespace } from 'vuex-class';
    import { africaOptions } from '../globals';
    import { EventBus } from '../helpers/bus';
    import { toggleIOsFix } from '../helpers/utils';
    import BaseComponent from './Base';
    import EnquireForm from './EnquireForm.vue';

    const UiStore = namespace('ui');

    @Component({
    components: {
        EnquireForm,
    },
})
export default class EnquireFormFixed extends BaseComponent {
    @Prop({ type: String, default: '[]' }) protected readonly marketingSourceOptions: string;
    @UiStore.State('enquireFormToggled') protected readonly isToggled: boolean;
    @UiStore.State('enquireFormVisible') protected readonly isVisible: boolean;
    @UiStore.Mutation('toggleEnquireForm') protected toggleEnquireForm: (state?: boolean) => void;

    protected selectedTourId: number | null = null;
    protected selectedDestinationId: number | null = null;
    protected isSmallDevice: boolean = false;
    protected onResizeThrottled: any = throttle(this.onResize, 500);

    protected get scrollOps(): any {
        return {
            vuescroll: {
                mode: 'native',
            },
            scrollPanel: {
                scrollingX: false,
                speed: 300,
                easing: 'easeInCubic',
            },
            rail: {
                background: 'transparent',
                width: '8px',
                opacity: 1,
            },
            bar: {
                background: 'rgba(255,255,255, .2)',
                keepShow: true,
            },
        };
    }

    protected onStepChanged(): void {
        (this.$refs.vScroll as any).scrollTo({
            x: 0,
            y: 0,
        }, false);
    }

    protected toggle(state?: boolean, emit = true): void {
        this.toggleEnquireForm(state);
        if (emit) {
            EventBus.$emit('enquireForm:toggle', this.isToggled);
        }
        if (!this.isSmallDevice) {
            return;
        }
        if (ios) {
            toggleIOsFix(this.isToggled);
        }
    }

    protected onResize(): void {
        this.isSmallDevice = window.innerHeight <= 800;
    }

    protected mounted(): void {
        this.onResize();
        window.addEventListener('resize', this.onResizeThrottled, { passive: true });

        EventBus.$on('enquireForm:dateSet', (dateTime: number | null) => {
            this.toggle(dateTime !== null, false);
        });
    }

    protected beforeDestroy(): void {
        window.removeEventListener('resize', this.onResizeThrottled);
    }

    protected created(): void {
        const controller: string = get(africaOptions, 'page.controller');
        switch (controller) {
            case 'tour':
                this.selectedTourId = get(africaOptions, 'page.id', null);
                break;
            case 'destination':
                this.selectedDestinationId = get(africaOptions, 'page.id', null);
                break;
            default:
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EnquireFormFixed.vue